export class MailUsersActionsAddOrReplaceParams {
  statut: string;
  action: string;
  transmisDate: string;
  echeance: string;
  message: string;
  accuseDeReponse: boolean;
  libre: string;
  serviceProprietaireId: number;
  serviceDestinataireId: number;
  contacts: [
    {
      contactIdiAdmin: number;
      contactId: number;
      historiqueDescription: string;
    },
  ];
  idsToReplace: number[];

  constructor(data?) {
    Object.assign(this, data);
  }
}
